import { Body4 } from '../../common/typography';
import styled from 'styled-components';

export const BoostersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
`;

export const BoostersContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const MyBoosterHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const MyBoosterHeaderContent = styled.div``;

export const MyBoosterRocketIcon = styled.div`
  margin-right: ${({ theme }) => theme.spacing.s};
`;

export const MyBoosterHeaderSubtitle = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const MyBoosterContent = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xm};
  display: grid;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const BoosterCardWrapper = styled.div``;

export const IconWrapper = styled.div``;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.error};
`;

export const EmptyMessage = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SkeletonCardWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const SkeletonTabWrapper = styled.div`
  margin-right: ${({ theme }) => theme.spacing.m};
`;

export const SkeletonContentWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;

export const TopicArticle = styled.article`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const TopicSection = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const TopicHeader = styled.header`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const StepContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const StepSection = styled.section`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const ObjectiveSection = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;
